(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-contact"] && !Shopify.designMode) return;
  try {
    

$('.contact-button').prop("disabled", false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-faq"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
$('.answer').hide();
$('.question-heading').click(function () {
$(this).next().slideToggle(200);
$(this).toggleClass("expanded");

});
$('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-hero"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    // Handle anchor scroll buttons
    const anchorScrollBtns = document.querySelectorAll('.anchor-scroll-btn');
    
    anchorScrollBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetSelector = this.getAttribute('data-target');
            if (!targetSelector) return;
            
            // Find the target element
            let targetElement;
            
            // Check if it's an ID selector (starts with #)
            if (targetSelector.startsWith('#')) {
                targetElement = document.querySelector(targetSelector);
            } 
            // Check if it's a class selector (starts with .)
            else if (targetSelector.startsWith('.')) {
                targetElement = document.querySelector(targetSelector);
            }
            // If no prefix, assume it's an ID
            else {
                targetElement = document.querySelector('#' + targetSelector);
            }
            
            // If target element exists, scroll to it smoothly
            if (targetElement) {
              const headerHeight = 170;
              const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
              const offsetPosition = elementPosition - headerHeight;

              window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
              });


            } else {
                console.warn('Anchor scroll target not found:', targetSelector);
            }
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-ui-faq"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  var answers = document.querySelectorAll('.answer');
  var questionHeadings = document.querySelectorAll('.question-heading');

  for (var i = 0; i < answers.length; i++) {
    answers[i].style.display = 'none';
  }

  for (var i = 0; i < questionHeadings.length; i++) {
    questionHeadings[i].addEventListener('click', function() {
      var answer = this.nextElementSibling;
      answer.style.display = (answer.style.display === 'none') ? 'block' : 'none';
      this.classList.toggle('expanded');
    });
  }

  for (var i = 0; i < answers.length; i++) {
    answers[i].style.display = 'none';
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-ui-stylesheet"] && !Shopify.designMode) return;
  try {
    


// Magic ATC

document.addEventListener("DOMContentLoaded",()=>{
    document.querySelectorAll('[data-pf-type="ProductATC"]').forEach(button=>{
        if (button.getAttribute("data-product.available")=="false") {
            button.innerText=button.getAttribute("data-soldout");
            return;
        }
        button.addEventListener("click",(event)=>{
            event.preventDefault();
            doATC(button);
        });
    });
});

function doATC(el) {
    el.innerText = el.getAttribute("data-adding");
    window.fetch("/cart/add.js",{
        method:"POST",
        credentials:"same-origin",
        headers:{
          "content-type":"application/json"
        },
        body:JSON.stringify({
            id:el.getAttribute("data-product-id"),
            quantity:1,
        })
    })
    .then(response=>response.json())
    .then(json=>{
        el.innerText = el.getAttribute("data-added");
        document.dispatchEvent(new CustomEvent(el.getAttribute("data-callback"),{bubbles:true}));
    });
}
  // New cart drawer (Dawn-style). Legacy atc:gocart / atc:smartcart events
  // continue to resolve — both are re-bound to open <cart-drawer> so the 30+
  // merchant-saved section schema values (`atc:gocart`, `atc:smartcart`) keep working.
  function openNewCartDrawer(e) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(e && e.target instanceof HTMLElement ? e.target : null);
    }
  }
  document.addEventListener("atc:gocart", openNewCartDrawer);
  document.addEventListener("atc:smartcart", openNewCartDrawer);
  document.addEventListener("atc:checkout",()=>location.href="/checkout");
  document.addEventListener("atc:cartpage",()=>location.href="/cart");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-carousel"] && !Shopify.designMode) return;
  try {
    
// The title link renders with its configured URL, so it still works with no JS
// and on pages that don't have the anchor section. A delegated click handler
// sends it to the on-page anchor instead whenever that target actually exists.
// Liquid isn't processed in these blocks (Shopify bundles them into one
// scripts.js), so the anchor ID travels on a data attribute.
document.addEventListener('click', function (e) {
  var link = e.target.closest ? e.target.closest('.shop-all-link[data-link-anchor]') : null;
  if (!link) return;
  var anchorId = link.getAttribute('data-link-anchor');
  if (!anchorId || !document.getElementById(anchorId)) return;
  e.preventDefault();
  window.location.hash = anchorId;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-component-our-process"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
$('.answer').hide();
$('.question-heading').click(function () {
$(this).next().slideToggle(200);
$(this).toggleClass("expanded");

});
$('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-component-shipping"] && !Shopify.designMode) return;
  try {
    
// Liquid variables aren't processed inside {% javascript %} blocks (Shopify
// bundles them into a single auto-generated scripts.js). The previous version
// used '#section-{{ section.id }} ...' which emitted the literal placeholder
// into scripts.js and threw a SyntaxError on every page that included this
// section. Use a page-wide selector — matches the pattern in component-hero.
document.addEventListener('DOMContentLoaded', function() {
  const anchorScrollBtns = document.querySelectorAll('.anchor-scroll-btn');
  anchorScrollBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const targetSelector = this.getAttribute('data-target');
      if (!targetSelector) return;
      let targetElement = targetSelector.startsWith('#') ? document.querySelector(targetSelector) : document.querySelector('#' + targetSelector);
      if (targetElement) {
        const headerHeight = 170;
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-new-testimonial"] && !Shopify.designMode) return;
  try {
    
// The CTAs render with their product link, so they still work with no JS and
// on pages that don't have the anchor section. A delegated click handler sends
// them to the on-page anchor instead whenever that target actually exists --
// delegation rather than rewriting hrefs up front, because slick clones slides
// and the clones would otherwise keep whichever href they were copied with.
// Liquid isn't processed in these blocks (Shopify bundles them into one
// scripts.js), so the anchor ID travels on a data attribute.
document.addEventListener('click', function (e) {
  var cta = e.target.closest ? e.target.closest('.new-cta[data-cta-anchor]') : null;
  if (!cta) return;
  var anchorId = cta.getAttribute('data-cta-anchor');
  if (!anchorId || !document.getElementById(anchorId)) return;
  e.preventDefault();
  window.location.hash = anchorId;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
$(document).ready(function () {

    $('.mob-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.mobile-child').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();
})();
